<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Фамилия
        .form-elem__main
          .input {{lastName}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Имя
        .form-elem__main
          .input {{firstName}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Отчество
        .form-elem__main
          .input {{fathersName}}
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Пол
        .form-elem__main
          .input {{localGender}}
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Дата рождения
        .form-elem__main
          .input {{localDateOfBirth}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Место рождения
        .form-elem__main
          .input {{placeOfBirth}}
    .form__elem(
      v-if="isAccompanying"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Сопровождающий делегации
        .form-elem__main
          label.checkbox
            input(
            v-model="isAccompanying"
            type="checkbox"
            disabled="true"
            )
            .checkbox__text
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "operator-form-info",
  components: {
    DatePicker,
  },
  props: {
    lastName: {
      type: String,
      default: "",
    },
    firstName: {
      type: String,
      default: "",
    },
    fathersName: {
      type: String,
      default: "",
    },
    gender: {
      type: [Boolean, Object, String],
      default: null,
    },
    dateOfBirth: {
      type: [String, Object],
      default: null,
    },
    placeOfBirth: {
      type: [String, Object],
      default: null,
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localGender() {
      if (this.gender) {
        return "Мужской";
      } else {
        return "Женский";
      }
    },
    localDateOfBirth() {
      let date = null;
      date = this.dateOfBirth.split("-");
      date = date.reverse();
      date = date.join(".");
      return date;
    },
  },
};
</script>
